import { render, staticRenderFns } from "./cover-image.vue?vue&type=template&id=21fbad2f&scoped=true&"
import script from "./cover-image.vue?vue&type=script&lang=js&"
export * from "./cover-image.vue?vue&type=script&lang=js&"
import style0 from "./cover-image.vue?vue&type=style&index=0&id=21fbad2f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fbad2f",
  null
  
)

export default component.exports